import { render } from "./ContactsPages.vue?vue&type=template&id=57ce186e&scoped=true"
import script from "./ContactsPages.vue?vue&type=script&lang=js"
export * from "./ContactsPages.vue?vue&type=script&lang=js"

import "./ContactsPages.vue?vue&type=style&index=0&id=57ce186e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ce186e"]])

export default __exports__